import React, { useEffect, useRef, useState } from "react";
import styles from "../AssistantTestModule.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { PaperPlaneIcon } from "@radix-ui/react-icons";
import { assistantInstructionRebuild } from "../../../utils/api/actions/assistant";
import { setActiveDialog } from "../../../store/slices/dialogSlice";
import { getAllDialogs } from "../../../utils/api/actions/dialogs";
import Markdown from "react-markdown";

export const DialogTest = ({ assistantName, openSettings }) => {
  const dispatch = useDispatch();
  const textareaRef = useRef(null);

  const activeAssistant = useSelector(
    (state) => state?.assistant?.activeAssistant
  );
  const user = useSelector((state) => state?.user?.data);
  const dialogs = useSelector((state) => state.dialog.data);
  const activeDialog = useSelector((state) => state.dialog.activeDialog);

  const assistantDialogs = dialogs.filter(
    (dialog) => dialog?.settings?.assistantId === activeAssistant?.id
  );

  console.log("assistantDialogs", assistantDialogs);

  const [dialogId, setDialogId] = useState("");
  const [message, setMessage] = useState("");
  const [localMessages, setLocalMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  console.log("dialogId", dialogId);

  useEffect(() => {
    if (dialogs.length === 0 && user?.id) {
      dispatch(getAllDialogs(user.id));
    }
  }, [dialogs, user, dispatch]);

  console.log("activeDialog", activeDialog);

  useEffect(() => {
    if (activeDialog?.histories?.length) {
      const formatted = activeDialog.histories.map((msg) => ({
        role: msg.role,
        content: extractMessage(msg.content, msg.role),
      }));
      setLocalMessages(formatted.reverse());
    }
  }, [activeDialog]);

  const extractMessage = (raw, role) => {
    if (!raw) return "";

    const pattern =
      role === "user"
        ? /<user_message>(.*?)<\/user_message>/s
        : /<text>(.*?)<\/text>/s;

    const match = raw.match(pattern);
    return match ? match[1].trim() : raw;
  };

  const getShortName = () => {
    const parts = `${user?.surname} ${user?.firstName} ${user?.patronymic}`
      .trim()
      .split(" ");
    return `${parts[0]} ${parts[1]?.[0]?.toUpperCase() || ""}.${
      parts[2]?.[0]?.toUpperCase() || ""
    }.`;
  };

  const handleSendMessage = async () => {
    if (!message.trim()) return;

    const tempUserMessage = { role: "user", content: message };
    setLocalMessages((prev) => [tempUserMessage, ...prev]);
    setLoading(true);

    const data = {
      userId: user.id,
      assistantId: activeAssistant?.id,
      dialogId: activeDialog?.id || dialogId || "",
      message,
    };

    setMessage("");
    textareaRef.current?.focus();

    await dispatch(assistantInstructionRebuild(data));
    setLoading(false);
  };

  const handleSetActiveDialog = (id) => {
    const dialog = dialogs.find((d) => d.id === id);
    dispatch(setActiveDialog(dialog));
    setDialogId(id);
  };

  const renderMessages = () => {
    return localMessages.map((msg, index) =>
      msg.role === "user" ? (
        <div key={index} className={styles.messageOutcome}>
          <div className={styles.name}>{getShortName()}</div>
          <div className={styles.messageText}>
            <p>{msg.content}</p>
          </div>
        </div>
      ) : (
        <div key={index} className={styles.messageIncome}>
          <div className={styles.name}>{assistantName}</div>
          <div className={styles.messageText}>
            <Markdown>{msg.content}</Markdown>
          </div>
        </div>
      )
    );
  };

  return (
    <div className={styles.dialogWrapper}>
      <div
        className={`${styles.dialogList} ${
          openSettings ? styles.dialogListHidden : ""
        }`}
      >
        <div className={styles.testTitle}>Диалоги</div>
        <div className={styles.dialogItemsContainer}>
          {assistantDialogs.length === 0 && (
            <div className={styles.noContent}>Нет диалогов</div>
          )}
          {assistantDialogs.map((dialog) => (
            <div
              key={dialog.id}
              className={
                dialog?.id === activeDialog?.id
                  ? `${styles.dialogItem} ${styles.activeDialogItem}`
                  : styles.dialogItem
              }
              onClick={() => handleSetActiveDialog(dialog.id)}
            >
              {dialog.name}
            </div>
          ))}
        </div>
      </div>

      <div className={styles.test}>
        <div className={styles.testTitle}>Тестирование ассистента</div>
        <div className={styles.messages}>
          {localMessages.length === 0 && (
            <div className={`${styles.noContent} ${styles.jcc}`}>
              Нет сообщений
            </div>
          )}
          {loading && (
            <div className={styles.typing}>
              Ассистент печатает
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </div>
          )}
          {renderMessages()}
        </div>
        <div className={styles.inputContainer}>
          <textarea
            ref={textareaRef}
            placeholder="Введите запрос..."
            rows="3"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault(); // предотвращаем перенос строки
                handleSendMessage();
              }
            }}
          />
          <div className={styles.send} onClick={handleSendMessage}>
            <PaperPlaneIcon color="white" size={25} />
          </div>
        </div>
      </div>
    </div>
  );
};
